<form class="quickop" id="quickop" autocomplete="off">

  <mat-form-field matNativeControl class="quickop_form is-fullwidth" appearance="fill" width='100%'  color="primary">
    <mat-label><i class="fas fa-project-diagram"></i> add operation</mat-label>
    <input type="text"
           placeholder=""
           matInput
           [formControl]="myControl"
           [matAutocomplete]="auto"
           >
      
           <mat-autocomplete 
           autoActiveFirstOption 
           #auto="matAutocomplete"
           (optionSelected) = addOpFromSearch($event)>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}}
            </mat-option>
    </mat-autocomplete>
    </mat-form-field>
  </form>